import * as React from "react";

import { cn } from "@/lib/utils";
import {
  customElementAttributeMappers,
  setCustomElementMetadata,
} from "@/lib/customElements";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

setCustomElementMetadata({
  component: Textarea,
  tagName: "raes-textarea",
  observedAttributes: {
    name: customElementAttributeMappers.string,
    placeholder: customElementAttributeMappers.string,
    disabled: customElementAttributeMappers.boolean,
    required: customElementAttributeMappers.boolean,
    rows: customElementAttributeMappers.number,
    value: (value: string) => ({
      value,
      prop: "defaultValue",
    }),
  },
});

export { Textarea };
